import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Loader2, Newspaper } from 'lucide-react';
import PageHero from '../../components/public/PageHero';
import Reveal from '../../components/public/Reveal';
import api from '../../lib/api';

export default function Noticias() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/news')
      .then(({ data }) => setArticles(data))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHero
        eyebrow="Noticias"
        title="El pulso del sector inmobiliario boliviano"
        description="Anuncios institucionales, análisis de mercado, eventos y novedades de la red CNIB."
      />

      <section className="py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center py-20" data-testid="news-loading">
              <Loader2 className="h-10 w-10 animate-spin text-cnib-blue" />
            </div>
          ) : articles.length === 0 ? (
            <div className="rounded-3xl border border-dashed border-slate-200 py-20 text-center" data-testid="news-empty">
              <Newspaper className="mx-auto h-10 w-10 text-slate-300" />
              <p className="mt-4 text-slate-500">Aún no hay noticias publicadas.</p>
            </div>
          ) : (
            <div className="grid gap-8 md:grid-cols-2" data-testid="news-grid">
              {articles.map((article, i) => (
                <Reveal key={article.article_id} delay={(i % 2) * 0.1}>
                  <Link
                    to={`/noticias/${article.slug}`}
                    data-testid={`news-card-${i}`}
                    className="group block h-full overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
                  >
                    {article.image_url && (
                      <div className="h-60 overflow-hidden">
                        <img
                          src={article.image_url}
                          alt={article.title}
                          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                    )}
                    <div className="p-7">
                      <div className="flex items-center gap-3 text-xs">
                        <span className="rounded-full bg-orange-500/10 px-3 py-1 font-bold text-orange-600">
                          {article.category}
                        </span>
                        <span className="flex items-center gap-1 text-slate-400">
                          <Calendar className="h-3.5 w-3.5" />
                          {new Date(article.created_at).toLocaleDateString('es-BO', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          })}
                        </span>
                      </div>
                      <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-slate-900 transition-colors group-hover:text-cnib-blue">
                        {article.title}
                      </h3>
                      <p className="mt-3 text-sm leading-relaxed text-slate-600">{article.excerpt}</p>
                      <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-orange-500">
                        Leer noticia
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
